import ColorX from "IZOX/STATIC/ColorX";

/**
 * @type {import("IZOX/__Typedef/sysconfig").SysConfig}
 */
export const SysConfig = {
  Project: {
    Name: "InsureNet - Web",
    ID: "insurenetweb",
    StartDate: process.env.REACT_APP_STARTDATE || "2023-09",
    FirstPage: "/Home",
    LogoutPage: "/",
    publicPath: ["/"]
  },
  Settings: {
    hasContainer: true,
    serverCheck: true,
    loggedCheck: true,
    loginSys: true
  },
  Snackbar: {
    position: "bottom",
    offset: 100,
    fontSize: 12,
    iconSize: 12,
    color: "white",
    duration: {
      success: 3000,
      warning: 6000,
      info: 4000,
      error: 6000
    }
  },
  Dialog: {
    Title: {
      bgColor: ColorX.CSS("NotQuiteWhite"),
      color: ColorX.CSS("pureDark"),
      fontSize: 14
    },
    Content: {
      bgColor: ColorX.CSS("pureWhite"),
      color: ColorX.CSS("pureDark"),
      fontSize: 12,
      fontFamily: "Arial",
      minHeight: 150
    },
    Button: {
      fontSize: 14
    }
  },
  IdleTime: 1800,
  ContentWidth: 1440,
  delayAfterPress: 500,
  longPressDuration: 3000,
  showLoadingButton: false,
  RefreshDelay: 60,
  RefreshTime: 60,
  WebUIWidth: 1440,
  screenSizeBreakpoints: [480, 768, 1024, 1200]
};

